import React from 'react';
import { ref } from 'firebase/database';
import { useDatabase, useDatabaseObjectData } from 'reactfire';
import moment from 'moment/moment';
import { PhoneIcon } from '@heroicons/react/24/outline';
import { AUDIO_CALL_STATUS } from 'common/components/constant';
import { getParticipantGroupAudioCallPath } from 'helpers/firebasePaths';

interface Props {
  session_id: string;
  participant_group_id: number;
}

interface AudioCallData {
  status?: string;
  requested_timestamp?: string;
  disconnected_timestamp?: string;
  initiated_timestamp?: string;
}

const getIcon = (timestamp: string) => {
  const timestampMoment = moment(timestamp);
  if (moment().diff(timestampMoment, 'minutes') < 1) {
    return <PhoneIcon type="solid" className="h-5 w-5 fill-orange-500 stroke-orange-500" />;
  }
  if (moment().diff(moment(timestamp), 'minutes') >= 1) {
    return <PhoneIcon type="solid" className="h-5 w-5 fill-red-700 stroke-red-700" />;
  }
  return null;
};

export const CallStatus: React.FC<Props> = ({ session_id, participant_group_id }) => {
  let icon = null;
  const database = useDatabase();
  const callRef = ref(database, getParticipantGroupAudioCallPath(participant_group_id, session_id));
  const { data: audioCallData } = useDatabaseObjectData<AudioCallData>(callRef);

  if (audioCallData) {
    switch (audioCallData?.status) {
      case AUDIO_CALL_STATUS.REQUESTED:
        icon = getIcon(audioCallData.requested_timestamp);
        break;
      case AUDIO_CALL_STATUS.INITIATED:
      case AUDIO_CALL_STATUS.CONNECTED:
      case AUDIO_CALL_STATUS.DISCONNECTED:
        icon = <PhoneIcon type="solid" className="h-5 w-5 fill-green-700 stroke-green-700" />;
        break;
      case AUDIO_CALL_STATUS.STALE:
        if (moment(audioCallData?.disconnected_timestamp) > moment(audioCallData?.initiated_timestamp)) {
          icon = <PhoneIcon type="solid" className="h-5 w-5 fill-green-700 stroke-green-700" />;
        }
        break;
      default:
        icon = null;
    }
  }

  return icon;
};
